import styled from 'styled-components'
import { createModal } from '@/components/modalize/mui'
import { breakpoints } from '@/styles'
import AddendumView from './addendum-view'

const ScrollWrapper = styled.div`
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 25px 0;
  min-width: 640px;

  // use after for bottom padding due to Firefox bug:
  // https://stackoverflow.com/questions/29986977
  :after {
    content: '';
    display: block;
    padding-bottom: 50px;
    width: 100%;
  }

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    min-width: unset;
  }
`

const AddendumModalView = ({ addendum = {}, contractId, variables = {}, signed = false }) => {
  return (
    <ScrollWrapper>
      <AddendumView
        contractId={contractId}
        addendum={addendum}
        variables={variables}
        signed={signed}
      />
    </ScrollWrapper>
  )
}

export const showAddendumModalView = createModal(AddendumModalView, {
  width: 'auto',
  maxWidth: '805px'
})
